import { apiClient } from './axios';

import type {
  AgentDefinition,
  ConfigurationAgent,
  CreateAgentDefinitionDto,
  UpdateAgentDefinitionDto,
  UpsertConfigurationAgentsDto,
} from '@repo/shared-types';

export const agentDefinitionsApi = {
  getAgentDefinitions: async (): Promise<AgentDefinition[]> => {
    const response = await apiClient.get<AgentDefinition[]>('/agent-definitions');
    return response.data;
  },

  getAgentDefinition: async (id: string): Promise<AgentDefinition> => {
    const response = await apiClient.get<AgentDefinition>(`/agent-definitions/${id}`);
    return response.data;
  },

  createAgentDefinition: async (data: CreateAgentDefinitionDto): Promise<AgentDefinition> => {
    const response = await apiClient.post<AgentDefinition>('/agent-definitions', data);
    return response.data;
  },

  updateAgentDefinition: async (
    id: string,
    data: UpdateAgentDefinitionDto,
  ): Promise<AgentDefinition> => {
    const response = await apiClient.patch<AgentDefinition>(`/agent-definitions/${id}`, data);
    return response.data;
  },

  deleteAgentDefinition: async (id: string): Promise<void> => {
    await apiClient.delete(`/agent-definitions/${id}`);
  },

  getConfigurationAgents: async (configId: string): Promise<ConfigurationAgent[]> => {
    const response = await apiClient.get<ConfigurationAgent[]>(
      `/configurations/${configId}/agents`,
    );
    return response.data;
  },

  upsertConfigurationAgents: async (
    configId: string,
    data: UpsertConfigurationAgentsDto,
  ): Promise<ConfigurationAgent[]> => {
    const response = await apiClient.post<ConfigurationAgent[]>(
      `/configurations/${configId}/agents`,
      data,
    );
    return response.data;
  },
};
